/**
 * Calcula e formata o tempo decorrido desde uma data.
 * @param {string} dateString - A data de início no formato ISO.
 * @returns {{text: string, className: string}} Objeto com o texto formatado e a classe de cor correspondente.
 */
export const formatTimeAgo = (dateString) => {
    // Pega a data e hora atual
    const now = new Date();
    // Converte a string da data de entrada para um objeto Date
    const startDate = new Date(dateString);
    // Calcula a diferença em milissegundos
    const diffTime = Math.abs(now - startDate);
    // Converte a diferença de milissegundos para dias
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    // Se a diferença for de até 30 dias, formata em dias
    if (diffDays <= 30) {
        return { 
            text: `há ${diffDays} dia${diffDays > 1 ? 's' : ''}`,
            className: 'bg-green-100 text-green-800 dark:bg-green-900/50 dark:text-green-300 border-green-300'
        };
    // Se a diferença for de até 365 dias, formata em meses
    } else if (diffDays <= 365) {
        const diffMonths = Math.floor(diffDays / 30);
        return { 
            text: `há ${diffMonths} mês${diffMonths > 1 ? 'es' : ''}`,
            className: 'bg-orange-100 text-orange-800 dark:bg-orange-900/50 dark:text-orange-300 border-orange-300'
        };
    // Se for mais de um ano, formata em anos
    } else {
        const diffYears = Math.floor(diffDays / 365);
        return { 
            text: `há ${diffYears} ano${diffYears > 1 ? 's' : ''}`,
            className: 'bg-red-100 text-red-800 dark:bg-red-900/50 dark:text-red-300 border-red-300'
        };
    }
};
